<template>
  <div id="app">
    <el-container style="min-height: 100vh; padding-top: 0.6rem">
      <el-header style="position: fixed; top: 0" id="header">
        <div class="logo">
          <!-- <img src="./assets/img/toplogo.png" alt /> -->
          <div class="logo-title">
            <p>四川长虹民生物流股份有限公司</p>
            <!-- <img src="./assets/img/logo-title.png" alt /> -->
          </div>
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          text-color="#fff"
          @select="handleSelect"
          :router="router"
        >
          <template v-for="item in navWebsiteConfig">
            <template v-if="!item.children">
              <el-menu-item
                :index="item.index"
                v-text="item.name"
                :key="item.index"
              ></el-menu-item>
            </template>
            <template v-else>
              <el-submenu :index="item.index" :key="item.index">
                <template slot="title">{{ item.name }}</template>
                <div class="my-menu-item">
                  <el-menu-item
                    :index="sub.index"
                    v-for="sub in item.children"
                    :key="sub.index"
                    v-text="sub.name"
                  >
                  </el-menu-item>
                </div>
              </el-submenu>
            </template>
          </template>
        </el-menu>
      </el-header>

      <el-main>
        <div class="bannerImg">
          <img :src="imgUrlBanner" v-if="!isBanner" alt="" />
        </div>
        <router-view :key="$route.fullPath" />
      </el-main>
      <!-- <div class="footer" :style="`background:url(${require(`./assets/img/footer-background.png`)}) no-repeat 0 0/ 100%`" v-show="isShow"> -->
      <div class="footer" v-show="isShow">
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <div style="display: flex">
                <div>
                  <h3 style="font-size: 14px !important">
                    <i class="el-icon-phone"></i> &nbsp;联系电话：
                  </h3>
                  <div>
                    <p style="font-size: 14px">{{ footerObj.tel }}</p>
                    <!-- <span>华东：0831-6889320 </span>
                <span>西北西南：0831-6889910</span> -->
                  </div>
                </div>
                <div style="margin-left: 50px">
                  <h3 style="font-size: 14px !important">
                    <i class="el-icon-location-outline"></i> &nbsp;公司地址：
                  </h3>
                  <div>
                    <p style="font-size: 14px">
                      {{ footerObj.address }}
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div style="display: flex">
                <div>
                  <h3 style="font-size: 14px !important">
                    <i class="el-icon-shopping-cart-2"></i> &nbsp;公司平台：
                  </h3>
                  <div>
                    <p
                      style="font-size: 14px; cursor: pointer"
                      @click="openUrl(footerObj.companyAddress)"
                    >
                      优车优货平台：{{ footerObj.companyAddress }}
                    </p>
                    <!-- <p
                      style="font-size: 14px; cursor: pointer"
                      @click="openUrl(footerObj.kbAddress)"
                    >
                      捆绑业务平台：{{ footerObj.kbAddress }}
                    </p> -->
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <!-- <img :src="barCode" alt /> -->
          <!-- <img src="./assets/img/ercode.png" alt /> -->
          <div style="display: flex">
            <div>
              <img src="./assets/img/mswl.jpg" alt="" class="footer-img" />
              <div
                style="
                  text-align: center;
                  font-size: 14px;
                  color: #fff;
                  margin-top: -30px;
                "
              >
                长虹民生
                <div>(微信公众号)</div>
              </div>
            </div>
            <div>
              <img src="./assets/img/app.png" alt="" class="footer-img" />
              <div
                style="
                  text-align: center;
                  font-size: 14px;
                  color: #fff;
                  margin-top: -30px;
                "
              >
                优车优货司机版
                <div>(安卓端)</div>
              </div>
            </div>
            <div>
              <img
                src="./assets/img/mini_program.png"
                alt=""
                class="footer-img"
              />
              <div
                style="
                  text-align: center;
                  font-size: 14px;
                  color: #fff;
                  margin-top: -30px;
                "
              >
                优车优货司机版
                <div>(小程序)</div>
              </div>
            </div>
            <div>
              <img src="./assets/img/app_hz.png" alt="" class="footer-img" />
              <div
                style="
                  text-align: center;
                  font-size: 14px;
                  color: #fff;
                  margin-top: -30px;
                "
              >
                优车优货货主版
              </div>
            </div>
          </div>
        </div>
        <div class="copyright">
          <span style="font-size: 12px !important"
            >四川长虹民生物流股份有限公司 Copyright © 版权信息2017-{{
              new Date().getFullYear()
            }}
            <el-link
              href="https://beian.miit.gov.cn"
              target="_blank"
              type="primary"
              :underline="false"
              >蜀ICP备13005242号-3</el-link
            >
          </span>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import config from "./config/navconfig.js";
// import QRCode from 'qrcodejs2'
// import { mapGetters } from 'vuex';
import http from "./utils/http";
import getFileUrl from "./utils/urlHelp";
// import { Loading } from 'element-ui';
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      imgUrlBanner: "",
      footerImg: "",
      barCode: "",
      isShow: true,
      isBanner: true,
      // imgUrlBanner:'https://d1icd6shlvmxi6.cloudfront.net/gsc/HWHPSF/1f/d9/45/1fd9450986d643048083d90c034c0e7c/images/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%AC-%E8%B4%A8%E9%87%8F%E6%89%BF%E8%AF%BA/u4.png?pageId=e3c40a28-8180-4764-abbf-afc43aedf18e',
      navWebsiteConfig: config.navWebsiteConfig,
      navAdminConfig: config.navAdminConfig,
      footerObj: {
        banner: "",
        connectTel: "",
        companyAddress: "",
        netSalesPlatform: "",
        qrCode: "",
      },
      lastHeight: 0,
    };
  },
  methods: {
    openUrl(url) {
      window.open(url);
    },
    getUrl(str) {
      const res = getFileUrl(str);
      return res;
    },
    toQuality() {
      this.$router.push({ path: `/gywm/qualityCommitment` });
    },
    toBa() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index");
    },
    toGswj() {
      window.open(
        "http://182.131.3.111/noticeread/notice/view?uuid=hiFecvzOQWD8041XJPa7lQsIjveo5VPC&tab=01"
      );
    },
    handleSelect(key) {
      // this.isShow = this.defaultActive != key;
      if (key === "/humanResource/campusRecruitment") {
        // window.location.href='http://hrs.changhong.com/hrs_school_wx/index.html#/'
        window.open(
          "http://hrs.changhong.com/hrs_school_wx/index.html#/",
          "校园招聘"
        );
        // window.location.replace('www.baidu.com')
      }
      this.isShow = true;
    },
    // // 生成二维码
    // creatQrCode(str) {
    //   var qrcode = new QRCode(this.$refs.qrCodeUrl, {
    //     text: str,
    //     width: 100,
    //     height: 100,
    //     colorDark: '#000000',
    //     colorLight: '#ffffff',
    //     correctLevel: QRCode.CorrectLevel.H
    //   })
    // },
    handleScroll() {
      const height =
        document.documentElement.scrollTop || document.body.scrollTop;
      const headerDom = document.getElementById("header");
      if (height >= 60) {
        headerDom.style.position = "fixed";
        headerDom.style.top = "-0.6rem";
        headerDom.style.transition = "all 0.4s linear";
      }
      if (this.lastHeight > height) {
        headerDom.style.position = "fixed";
        headerDom.style.top = "0";
        headerDom.style.transition = "all 0.4s linear";
      }
      // else {
      //   headerDom.style.position = 'fixed';
      //   headerDom.style.top = '0';
      // }
      setTimeout(() => {
        this.lastHeight = height;
      }, 0);
    },
  },
  computed: {},
  created() {},
  mounted() {
    this.defaultActive = this.$route.path;
    http.post("/dictionary/getByCode", { groupType: 100 }).then((res) => {
      localStorage.setItem("productList", JSON.stringify(res.data));
      let arr = res.data.map((r) => {
        return {
          name: r.name,
          index: `/showProduct/${r.code}`,
          component: () => import("./views/ElectromechanicalComponents.vue"),
          path: `/showProduct/${r.code}`,
          meta: {
            title: r.name,
          },
        };
      });
      // this.navWebsiteConfig.forEach(item => {
      //   if (item.index === '/showProduct') {
      //     item.children = arr;
      //   }
      // });
      this.$router.addRoutes(arr);
    });
    window.addEventListener("scroll", this.handleScroll, true);

    http
      .post("/reception/homePage/getList", { groupType: "114" })
      .then((res) => {
        this.imgUrlBanner = getFileUrl(res.data[0].val);
      });

    http
      .post("/reception/homePage/getList", { groupType: "111" })
      .then((res) => {
        // this.footerImg = res.data[0].val
        res.data.forEach((item) => {
          this.footerObj[item.code] = item.val;
        });
      });
  },
  watch: {
    $route(to) {
      if (to.path === "/") {
        this.isBanner = true;
      } else {
        this.isBanner = false;
      }
      this.defaultActive = to.path;
    },
  },
};
</script>

<style lang="scss">
@import "base.scss";
.bannerImg {
  img {
    width: 100%;
    height: 2.67rem;
  }
}
.line {
  background-color: #ffffff;
  width: 1.5px;
  height: 16px;
  margin: 0 15px !important;
}
.footer-img {
  width: 1rem !important;
  height: 1rem !important;
  margin-top: 40px;
}
</style>
